import * as React from 'react';
import accounting from 'accounting';

import Button from 'src/components/common/Button';

import { ifLoggedIn, goToHome } from 'src/utils/navigation';
import './Summary.scss';

interface ISummaryProps {
  orderConfirmed: boolean;
  subtotal: number;
  taxTotal: number;
  total: number;
  placeOrder: () => void;
  reOrder: () => void;
  t?: any;
  placingOrderInProgress?: boolean;
  hasFailed: boolean;
}

class Summary extends React.Component<ISummaryProps, any> {
  private goToHome = () => ifLoggedIn(() => goToHome());

  public isDisabledPlaceOrder = (): boolean => {
    return (
      this.props.placingOrderInProgress ||  this.props.hasFailed
    );
  };
  public render() {
    const { t } = this.props;
    return (
      <div className="rp-checkout-summary">
        {this.props.orderConfirmed ? (
          <div className="rp-checkout-summary--order-confirmed ">
            <Button
              label={t('checkoutPage.reOrder')}
              action={this.props.reOrder}
              buttonClass="secondary-button rp-checkout-summary--re-order"
            />
            <Button
              label={t('checkoutPage.continueShopping')}
              action={this.goToHome}
              buttonClass="primary-button rp-checkout-summary--continue-shopping"
            />
          </div>
        ) : (
          <Button
            label={t('checkoutPage.placeOrder')}
            action={this.props.placeOrder}
            buttonClass="primary-button rp-checkout-summary--place-order"
            disabled={this.isDisabledPlaceOrder()}
          />
        )}
        <div className="rp-checkout-summary--breakdow">
          <div className="rp-checkout-summary--breakdow-title">
            {t('checkoutPage.orderSummary')}:
          </div>
          <div className="rp-checkout-summary--breakdow-row">
            <label>{t('checkoutPage.subTotal')}:</label>
            <span>{accounting.formatMoney(this.props.subtotal)}</span>
          </div>
          <div className="rp-checkout-summary--breakdow-row">
            <label>
              {t('checkoutPage.estimatedTax')}:
              <div className="shipping">
                <span className={`rpds-error shipping-icon`} />
                <div className="rp-checkout-summary--shipping-notification">
                  {t('common.estimatedTaxToolTip')}
                </div>
              </div>
            </label>
            <span>{accounting.formatMoney(this.props.taxTotal)}</span>
          </div>
          <div className="rp-checkout-summary--breakdow-row total">
            <label>{t('checkoutPage.orderTotal')}</label>
            <span>{accounting.formatMoney(this.props.total)}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Summary;
